import {Component, OnInit, ElementRef} from '@angular/core';
import {FormArray, FormControl, FormGroup, Validators} from "@angular/forms";
import {ConfiguracaoPlano} from "../../models/configuracao-plano";
import {ConfiguracaoPlanoService} from "../../services/configuracao-plano.service";
import {NgxSpinnerService} from "ngx-spinner";
import {ActivatedRoute, Router} from "@angular/router";
import {MessageService} from "../../core/services/message.service";
import {ConfiguracaoGrupoPlano} from "../../models/configuracao-grupo-plano";
import {ConfiguracaoGrupoPlanoService} from "../../services/configuracao-grupo-plano.service";
import {Objetivo} from "../../models/objetivo";
import {Meta} from "../../models/meta";
import {AcaoEstrategica} from "../../models/acao-estrategica";
import {Avaliacao} from "../../models/avaliacao";
import {OutraDefinicao} from "../../models/outra-definicao";
import {Plano} from "../../models/plano";
import {PlanoService} from "../../services/plano.service";
import {ExecucaoPlanoService} from "../../services/execucao-plano.service";
import {forkJoin, Observable} from "rxjs";
import {PlanoObjetivo} from "../../models/plano-objetivo";
import {PlanoAcaoEstrategica} from "../../models/plano-acao-estrategica";
import {PlanoAvaliacao} from "../../models/plano-avaliacao";
import {PlanoOutraDefinicao} from "../../models/plano-outra-definicao";
import {PlanoDiagnostico} from "../../models/plano-diagnostico";
import {PlanoMeta} from "../../models/plano-meta";
import {PlanoObjetivoOutro} from "../../models/plano-objetivo-outro";
import {PlanoMetaOutro} from "../../models/plano-meta-outro";
import {PlanoAcaoEstrategicaOutro} from "../../models/plano-acao-estrategica-outro";
import {PlanoAvaliacaoOutro} from "../../models/plano-avaliacao-outro";
import {PlanoOutraDefinicaoOutro} from "../../models/plano-outra-definicao-outro";
import {MatDialog} from "@angular/material";
import {DialogMetaAcaoEstrategicaComponent} from "../dialogs/dialog-meta-acao-estrategica/dialog-meta-acao-estrategica.component";
import {DialogTextoAuxiliarComponent} from "../dialogs/dialog-texto-auxiliar/dialog-texto-auxiliar.component";
import {DialogConfirmarSairComponent} from "../dialogs/dialog-confirmar-sair/dialog-confirmar-sair.component";
import {SituacaoPlano} from "../../models/situacao-plano";
import {isUndefined} from "util";
import {Login} from "../../models/login";
import {Perfil} from "../../models/perfil";
import {LoginService} from "../../services/login.service";
import {DialogConfirmarExclusaoMetaAcaoEstrategicaComponent} from "../dialogs/dialog-confirmar-exclusao-meta-acao-estrategica/dialog-confirmar-exclusao-meta-acao-estrategica.component";
import {TinymceService} from "../../core/services/tinymce.service";
import {FileSystemDirectoryEntry, FileSystemFileEntry, NgxFileDropEntry} from "ngx-file-drop";
import {ArquivoService} from "../../services/arquivo.service";
import {DialogTextoAnexoComponent} from "../dialogs/dialog-texto-anexo/dialog-texto-anexo.component";
import {DialogConfirmarExclusaoAnexoComponent} from "../dialogs/dialog-confirmar-exclusao-anexo/dialog-confirmar-exclusao-anexo.component";
import {AcompanhamentoService} from "../../services/acompanhamento.service";


@Component({
    selector: 'app-execucao-plano',
    templateUrl: './execucao-plano.component.html',
    styleUrls: ['./execucao-plano.component.scss']
})
export class ExecucaoPlanoComponent implements OnInit {

    panelOpenState = false;

    public configuracoes_plano: Array<ConfiguracaoPlano>;
    public configuracao_grupo_plano: ConfiguracaoGrupoPlano;
    public plano: Plano;
    public form: FormGroup;
    public cod_plano: number;
    public sgl_configuracao_grupo_plano: string;
    public carregando: boolean = false;
    public url_redirect: string = null;
    public desabilitar_definicoes = false;
    public possui_objetivos: boolean = false;
    public possui_metas: boolean = false;
    public possui_acoes_estrategicas: boolean = false;
    public possui_avaliacoes: boolean = false;
    public possui_outras_definicoes: boolean = false;
    public objetivo_outros_textos: Array<any> = [];
    public avaliacao_outros_textos: Array<any> = [];
    public acao_estrategica_outros_textos: Array<any> = [];
    public meta_outros_textos: Array<any> = [];
    public outra_definicao_outros_textos: Array<any> = [];
    public options_prazo_atualizacao: Array<any>;
    public options_periodicidade_revisao: Array<any>;
    public ordens: any;
    public form_alterado: boolean = false;
    public tabs: Array<{}>;
    public tab_index: number = 0;
    public disabled: Array<any>;
    public arquivos: Array<any> = [];
    public descricao_arquivo: string;
    public fileName: Array<File> = [];
    public diagnosticoChecklist: Array<any> = [];
    public objetivoChecklist: Array<any> = [];


    // Checklist dos Conjuntos de Abas
    public conjuntoAbasCheklist: Array<any> = [];
    public apresentacaoChecklist: Array<any> = [];
    public transporteColetivoChecklist: Array<any> = [];
    public circulacaoViariaChecklist: Array<any> = [];
    public infraestruturaChecklist: Array<any> = [];
    public acessibilidadeChecklist: Array<any> = [];
    public integracaoChecklist: Array<any> = [];
    public transporteCargaChecklist: Array<any> = [];
    public polosChecklist: Array<any> = [];
    public estacionamentoChecklist: Array<any> = [];
    public circulacaoRestritaChecklist: Array<any> = [];
    public financiamentoChecklist: Array<any> = [];
    public revisaoChecklist: Array<any> = [];
    private showChecklist: boolean = true;
    public showBtnFinalizar: boolean = false;

    constructor(private ref: ElementRef, private configuracaoPlanoService: ConfiguracaoPlanoService,
                private configuracaoGrupoPlanoService: ConfiguracaoGrupoPlanoService,
                private planoService: PlanoService, private execucaoPlanoService: ExecucaoPlanoService,
                private loadingService: NgxSpinnerService, private messageService: MessageService,
                private route: ActivatedRoute, private router: Router, private dialog: MatDialog,
                private arquivoService: ArquivoService,
                private loginService: LoginService,
                private acompanhamentoService: AcompanhamentoService) {

    }

    ngOnInit() {
        let login: Login = this.loginService.getAuth();
        let url: string;
        if (login) {
            if (login.perfil != Perfil.GESTOR) {
                url = "/gerencial";
                this.router.navigateByUrl(url);
            }
        } else {
            url = "/login";
            this.router.navigateByUrl(url);
        }
        this.tabs = [];
        this.ordens = {
            diagnostico: 0,
            objetivo: 0,
            meta: 0,
            acao_estrategica: 0,
            avaliacao: 0,
            outra_definicao: 0,
        };
        this.form = new FormGroup({});
        this.form_alterado = false;
        this.options_prazo_atualizacao = [
            {value: 4, description: "4"},
            {value: 5, description: "5"},
            {value: 6, description: "6"},
            {value: 7, description: "7"},
            {value: 8, description: "8"},
            {value: 9, description: "9"},
            {value: 10, description: "10"}
        ];
        this.options_periodicidade_revisao = [
            {value: 0, description: "Não"},
            {value: 2, description: "A cada 2 anos"},
            {value: 3, description: "A cada 3 anos"},
            {value: 5, description: "A cada 5 anos"}
        ];
        this.disabled = [];
        this.cod_plano = this.route.snapshot.params.plano;
        if (this.route.snapshot.params.configuracao_grupo_plano) {
            this.sgl_configuracao_grupo_plano = this.route.snapshot.params.configuracao_grupo_plano;
        } else {
            this.sgl_configuracao_grupo_plano = ConfiguracaoGrupoPlano.SIGLA_APRESENTACAO;
        }


        this.url_redirect = "/planos";
        let redirect: boolean = false;
        if (this.cod_plano) {

            this.arquivoService.listAll(this.cod_plano).subscribe(data => {
                this.arquivos = data;

            });
            this.carregarConfiguracoesGrupoPlano(this.cod_plano);
            this.carregarConfiguracaoGrupoPlano(this.sgl_configuracao_grupo_plano);
            // this.carregarRevisaoMinuta(this.cod_plano);
        } else {
            this.messageService.showError("Informe um plano de mobilidade");
            redirect = true;
        }

        if (redirect) {
            this.router.navigateByUrl(this.url_redirect);
        }
    }

    ngAfterViewInit() {


    }

    carregarConfiguracoesGrupoPlano(cod_plano: number = null): void {
        this.configuracaoGrupoPlanoService.listAll(cod_plano).subscribe((configuracoes_grupo_plano: Array<ConfiguracaoGrupoPlano>) => {
            configuracoes_grupo_plano.forEach((configuracao_grupo_plano: ConfiguracaoGrupoPlano, i: number) => {
                this.tabs.push({
                    sgl_configuracao_grupo_plano: configuracao_grupo_plano.sgl_configuracao_grupo_plano,
                    texto: configuracao_grupo_plano.dsc_configuracao_grupo_plano,
                    icon: (configuracao_grupo_plano.qtd_configuracoes_plano > 0 && configuracao_grupo_plano.qtd_configuracoes_plano == configuracao_grupo_plano.qtd_configuracoes_plano_respondidas) ? true : false,
                    color: (this.sgl_configuracao_grupo_plano == configuracao_grupo_plano.sgl_configuracao_grupo_plano) ? 'primary' : 'default'
                });
                if (this.sgl_configuracao_grupo_plano == configuracao_grupo_plano.sgl_configuracao_grupo_plano) {
                    this.tab_index = i;
                }

                // this.carregarConfiguracaoGrupoPlano(configuracao_grupo_plano.sgl_configuracao_grupo_plano, true
                // );


            });
            this.loadingService.hide();
        }, () => {
            this.loadingService.hide();
        });
    }

    getData(cod_plano: number, sgl_configuracao_grupo_plano: string): Observable<any> {
        return forkJoin([
            this.planoService.findById(cod_plano, true),
            this.configuracaoGrupoPlanoService.findBySigla(sgl_configuracao_grupo_plano, true)
        ]);
    }

    carregarConfiguracaoGrupoPlano(sgl_configuracao_grupo_plano: string, automatico: boolean =false): void {


        this.loadingService.show();
        this.carregando = true;
        this.desabilitar_definicoes = false;
        this.form = new FormGroup({});
        this.objetivo_outros_textos = [];
        this.meta_outros_textos = [];
        this.acao_estrategica_outros_textos = [];
        this.avaliacao_outros_textos = [];
        this.outra_definicao_outros_textos = [];
        this.plano = null;
        this.configuracao_grupo_plano = null;
        this.form_alterado = false;
        this.possui_objetivos = false;
        this.possui_metas = false;
        this.possui_acoes_estrategicas = false;
        this.possui_avaliacoes = false;
        this.possui_outras_definicoes = false;
        this.ordens = {
            diagnostico: 0,
            objetivo: 0,
            meta: 0,
            acao_estrategica: 0,
            avaliacao: 0,
            outra_definicao: 0,
        };

        this.getData(this.cod_plano, sgl_configuracao_grupo_plano).subscribe((data: any) => {

            this.plano = data[0] as Plano;

            this.configuracao_grupo_plano = data[1] as ConfiguracaoGrupoPlano;

            // aqui chamar revisao da minuta

            if (this.plano && this.plano.situacao_plano.sgl_situacao_plano == SituacaoPlano.FINALIZADO) {
                this.messageService.showAlert("O plano está finalizado e não pode ser alterado");
                this.router.navigateByUrl(this.url_redirect);
            }
            if (this.configuracao_grupo_plano) {



                this.configuracoes_plano = this.configuracao_grupo_plano.configuracoes_plano;

                if (this.configuracoes_plano.length > 0) {

                    let form_diagnostico: FormGroup = new FormGroup({});
                    let form_objetivos: FormGroup = new FormGroup({});
                    let form_metas: FormGroup = new FormGroup({});
                    let form_acoes_estrategicas: FormGroup = new FormGroup({});
                    let form_avaliacoes: FormGroup = new FormGroup({});
                    let form_outras_definicoes: FormGroup = new FormGroup({});
                    let form_arquivo: FormGroup = new FormGroup({});

                    this.configuracoes_plano.forEach((configuracao_plano: ConfiguracaoPlano) => {
                        let ordem: number = 1;
                        if (configuracao_plano.bln_objetivo || configuracao_plano.bln_meta || configuracao_plano.bln_acao_estrategica) {
                            this.ordens.diagnostico = ordem;
                            ordem++;
                        }
                        if (configuracao_plano.bln_objetivo) {
                            this.ordens.objetivo = ordem;
                            ordem++;
                        }
                        if (configuracao_plano.bln_meta) {
                            this.ordens.meta = ordem;
                            ordem++;
                        }
                        if (configuracao_plano.bln_acao_estrategica) {
                            this.ordens.acao_estrategica = ordem;
                            ordem++;
                        }
                        if (configuracao_plano.bln_avaliacao) {
                            if (this.ordens.diagnostico == 0) {
                                this.ordens.diagnostico = ordem;
                                ordem++;
                            }
                            this.ordens.avaliacao = ordem;
                            ordem++;
                        }
                        if (configuracao_plano.bln_outra_definicao) {
                            this.ordens.outra_definicao = ordem;
                        }
                        let txt_plano_diagnostico: string = configuracao_plano.txt_padrao;
                        let bln_desabilitar_preenchimento: boolean = false;
                        let prazo_atualizacao: number = null;
                        let periodicidade_revisao: number = null;
                        if (this.plano.diagnosticos.length > 0) {
                            this.plano.diagnosticos.forEach((plano_diagnostico: PlanoDiagnostico) => {
                                if (plano_diagnostico.cod_configuracao_plano == configuracao_plano.cod_configuracao_plano) {
                                    txt_plano_diagnostico = plano_diagnostico.txt_plano_diagnostico;
                                    bln_desabilitar_preenchimento = plano_diagnostico.bln_sem_definicoes;
                                    prazo_atualizacao = plano_diagnostico.prazo_atualizacao;
                                    periodicidade_revisao = plano_diagnostico.periodicidade_revisao;
                                }
                            });
                        }
                        let form_group_diagnostico: FormGroup = new FormGroup({});
                        form_group_diagnostico.addControl("texto", new FormControl(txt_plano_diagnostico));
                        if (configuracao_plano.bln_opcao_preenchimento) {
                            this.desabilitar_definicoes = bln_desabilitar_preenchimento;
                            form_group_diagnostico.addControl("desabilitar_definicoes", new FormControl(bln_desabilitar_preenchimento));
                        }
                        if (configuracao_plano.bln_avaliacao) {
                            form_group_diagnostico.addControl("prazo_atualizacao", new FormControl(prazo_atualizacao, [Validators.required]));
                            form_group_diagnostico.addControl("periodicidade_revisao", new FormControl(periodicidade_revisao, [Validators.required]));
                        }
                        // setTimeout(() => {
                        //     form_diagnostico.addControl(configuracao_plano.cod_configuracao_plano.toString(), form_group_diagnostico);
                        // }, 5000);
                        form_diagnostico.addControl(configuracao_plano.cod_configuracao_plano.toString(), form_group_diagnostico);

                        if (configuracao_plano.objetivos.length > 0 && configuracao_plano.bln_objetivo) {
                            this.possui_objetivos = true;
                            let form_objetivo: FormGroup = new FormGroup({});
                            this.disabled['objetivos'] = [];
                            this.disabled['objetivos'][configuracao_plano.cod_configuracao_plano] = [];
                            configuracao_plano.objetivos.forEach((objetivo: Objetivo) => {
                                this.disabled['objetivos'][configuracao_plano.cod_configuracao_plano][objetivo.cod_objetivo] = false;
                                let bln_objetivo: boolean = false;
                                this.objetivo_outros_textos[objetivo.cod_objetivo] = [];
                                let textos: Array<FormGroup> = [];
                                if (this.plano.objetivos && this.plano.objetivos.length > 0) {
                                    this.plano.objetivos.forEach((plano_objetivo: PlanoObjetivo) => {
                                        if (plano_objetivo.cod_objetivo == objetivo.cod_objetivo) {
                                            bln_objetivo = true;
                                            if (objetivo.bln_cadastrar_outros && plano_objetivo.outros && plano_objetivo.outros.length > 0) {
                                                this.disabled['objetivos'][configuracao_plano.cod_configuracao_plano][objetivo.cod_objetivo] = true;
                                                plano_objetivo.outros.forEach((outro: PlanoObjetivoOutro) => {
                                                    textos.push(new FormGroup({
                                                        codigo: new FormControl(outro.cod_plano_objetivo_outro),
                                                        descricao: new FormControl(outro.txt_plano_objetivo_outro)
                                                    }));
                                                    this.objetivo_outros_textos[objetivo.cod_objetivo].push({
                                                        codigo: outro.cod_plano_objetivo_outro,
                                                        descricao: txt_plano_diagnostico
                                                    });
                                                });
                                            }
                                        }
                                    });
                                }
                                if (objetivo.bln_cadastrar_outros && this.objetivo_outros_textos[objetivo.cod_objetivo].length == 0) {
                                    textos.push(new FormGroup({
                                        codigo: new FormControl(),
                                        descricao: new FormControl()
                                    }));
                                    this.objetivo_outros_textos[objetivo.cod_objetivo].push({
                                        codigo: null,
                                        descricao: null
                                    });
                                    this.disabled['objetivos'][configuracao_plano.cod_configuracao_plano][objetivo.cod_objetivo] = false;
                                }
                                form_objetivo.addControl(objetivo.cod_objetivo.toString(), new FormGroup({
                                    objetivo: new FormControl(bln_objetivo),
                                    textos: new FormArray(textos)
                                }));
                            });
                            form_objetivos.addControl(configuracao_plano.cod_configuracao_plano.toString(), form_objetivo);
                            form_objetivos.disable({onlySelf: false});
                        }
                        if (configuracao_plano.metas.length > 0 && configuracao_plano.bln_meta) {
                            this.possui_metas = true;
                            let form_meta: FormGroup = new FormGroup({});
                            configuracao_plano.metas.forEach((meta: Meta) => {
                                let bln_meta: boolean = false;
                                this.meta_outros_textos[meta.cod_meta] = [];
                                if (this.plano.metas && this.plano.metas.length > 0) {
                                    this.plano.metas.forEach((plano_meta: PlanoMeta) => {
                                        if (plano_meta.cod_meta == meta.cod_meta) {
                                            bln_meta = true;
                                            if (plano_meta.outros && plano_meta.outros.length > 0) {
                                                plano_meta.outros.forEach((outro: PlanoMetaOutro) => {
                                                    this.meta_outros_textos[meta.cod_meta].push({
                                                        codigo: outro.cod_plano_meta_outro,
                                                        descricao: outro.txt_plano_meta_outro
                                                    });
                                                });
                                            }
                                        }
                                    });
                                }
                                form_meta.addControl(meta.cod_meta.toString(), new FormGroup({
                                    meta: new FormControl(bln_meta),
                                }));
                            });
                            form_metas.addControl(configuracao_plano.cod_configuracao_plano.toString(), form_meta);
                        }
                        if (configuracao_plano.acoes_estrategicas.length > 0 && configuracao_plano.bln_acao_estrategica) {
                            this.possui_acoes_estrategicas = true;
                            let form_acao_estrategica: FormGroup = new FormGroup({});
                            configuracao_plano.acoes_estrategicas.forEach((acao_estrategica: AcaoEstrategica) => {
                                let bln_acao_estrategica: boolean = false;
                                this.acao_estrategica_outros_textos[acao_estrategica.cod_acao_estrategica] = [];
                                if (this.plano.acoes_estrategicas && this.plano.acoes_estrategicas.length > 0) {
                                    this.plano.acoes_estrategicas.forEach((plano_acao_estrategica: PlanoAcaoEstrategica) => {
                                        if (plano_acao_estrategica.cod_acao_estrategica == acao_estrategica.cod_acao_estrategica) {
                                            bln_acao_estrategica = true;
                                            if (plano_acao_estrategica.outros && plano_acao_estrategica.outros.length > 0) {
                                                plano_acao_estrategica.outros.forEach((outro: PlanoAcaoEstrategicaOutro) => {
                                                    this.acao_estrategica_outros_textos[acao_estrategica.cod_acao_estrategica].push({
                                                        codigo: outro.cod_plano_acao_estrategica_outro,
                                                        descricao: outro.txt_plano_acao_estrategica_outro
                                                    });
                                                });
                                            }
                                        }
                                    });
                                }

                                form_acao_estrategica.addControl(acao_estrategica.cod_acao_estrategica.toString(), new FormGroup({
                                    acao_estrategica: new FormControl(bln_acao_estrategica),
                                }));
                                form_acoes_estrategicas.addControl(configuracao_plano.cod_configuracao_plano.toString(), form_acao_estrategica);
                            });
                        }
                        if (configuracao_plano.avaliacoes.length > 0 && configuracao_plano.bln_avaliacao) {
                            this.disabled['avaliacoes'] = [];
                            this.disabled['avaliacoes'][configuracao_plano.cod_configuracao_plano] = [];
                            this.possui_avaliacoes = true;
                            let form_avaliacao: FormGroup = new FormGroup({});
                            configuracao_plano.avaliacoes.forEach((avaliacao: Avaliacao) => {
                                this.disabled['avaliacoes'][configuracao_plano.cod_configuracao_plano][avaliacao.cod_avaliacao] = false;
                                let bln_avaliacao: boolean = false;
                                let textos: Array<FormGroup> = [];
                                this.avaliacao_outros_textos[avaliacao.cod_avaliacao] = [];
                                if (this.plano.avaliacoes && this.plano.avaliacoes.length > 0) {
                                    this.plano.avaliacoes.forEach((plano_avaliacao: PlanoAvaliacao) => {
                                        if (plano_avaliacao.cod_avaliacao == avaliacao.cod_avaliacao) {
                                            bln_avaliacao = true;
                                            this.avaliacao_outros_textos[avaliacao.cod_avaliacao] = [];
                                            if (avaliacao.bln_cadastrar_outros && plano_avaliacao.outros && plano_avaliacao.outros.length > 0) {
                                                this.disabled['avaliacoes'][configuracao_plano.cod_configuracao_plano][avaliacao.cod_avaliacao] = true;
                                                plano_avaliacao.outros.forEach((outro: PlanoAvaliacaoOutro) => {
                                                    textos.push(new FormGroup({
                                                        codigo: new FormControl(outro.cod_plano_avaliacao_outro),
                                                        descricao: new FormControl(outro.txt_plano_avaliacao_outro)
                                                    }));
                                                    this.avaliacao_outros_textos[avaliacao.cod_avaliacao].push({
                                                        codigo: outro.cod_plano_avaliacao_outro,
                                                        descricao: outro.txt_plano_avaliacao_outro
                                                    });
                                                });
                                            }
                                        }
                                    });
                                }
                                if (avaliacao.bln_cadastrar_outros && this.avaliacao_outros_textos[avaliacao.cod_avaliacao].length == 0) {
                                    textos.push(new FormGroup({
                                        codigo: new FormControl(),
                                        descricao: new FormControl()
                                    }));
                                    this.avaliacao_outros_textos[avaliacao.cod_avaliacao].push({
                                        codigo: null,
                                        descricao: null
                                    });
                                    this.disabled['avaliacoes'][configuracao_plano.cod_configuracao_plano][avaliacao.cod_avaliacao] = false;
                                }

                                form_avaliacao.addControl(avaliacao.cod_avaliacao.toString(), new FormGroup({
                                    avaliacao: new FormControl(bln_avaliacao),
                                    textos: new FormArray(textos)
                                }));
                            });
                            form_avaliacoes.addControl(configuracao_plano.cod_configuracao_plano.toString(), form_avaliacao);
                        }
                        if (configuracao_plano.outras_definicoes.length > 0 && configuracao_plano.bln_outra_definicao) {
                            this.possui_outras_definicoes = true;
                            let form_outra_definicao: FormGroup = new FormGroup({});
                            configuracao_plano.outras_definicoes.forEach((outra_definicao: OutraDefinicao) => {
                                let bln_outra_definicao: boolean = false;
                                let textos: Array<FormGroup> = [];
                                this.outra_definicao_outros_textos[outra_definicao.cod_outra_definicao] = [];
                                let orgao_responsavel: string = "";
                                if (this.plano.outras_definicoes && this.plano.outras_definicoes.length > 0) {
                                    this.plano.outras_definicoes.forEach((plano_outra_definicao: PlanoOutraDefinicao) => {
                                        if (plano_outra_definicao.cod_outra_definicao == outra_definicao.cod_outra_definicao) {
                                            bln_outra_definicao = true;
                                            this.outra_definicao_outros_textos[outra_definicao.cod_outra_definicao] = [];
                                            if (outra_definicao.bln_cadastrar_outros && plano_outra_definicao.outros && plano_outra_definicao.outros.length > 0) {
                                                plano_outra_definicao.outros.forEach((outro: PlanoOutraDefinicaoOutro) => {
                                                    textos.push(new FormGroup({
                                                        codigo: new FormControl(outro.cod_plano_outra_definicao_outro),
                                                        descricao: new FormControl(outro.txt_plano_outra_definicao_outro)
                                                    }));
                                                    this.outra_definicao_outros_textos[outra_definicao.cod_outra_definicao].push({
                                                        codigo: outro.cod_plano_outra_definicao_outro,
                                                        descricao: outro.txt_plano_outra_definicao_outro
                                                    });
                                                });
                                            }
                                        }
                                    });
                                    if (this.plano.diagnosticos.length > 0) {
                                        this.plano.diagnosticos.forEach((plano_diagnostico: PlanoDiagnostico) => {
                                            if (plano_diagnostico.cod_configuracao_plano == configuracao_plano.cod_configuracao_plano) {
                                                orgao_responsavel = plano_diagnostico.orgao_responsavel;
                                            }
                                        });
                                    }
                                }

                                form_outra_definicao.addControl(outra_definicao.cod_outra_definicao.toString(), new FormGroup({
                                    outra_definicao: new FormControl(bln_outra_definicao),
                                }));
                                form_outra_definicao.addControl("orgao_responsavel", new FormControl(orgao_responsavel, [Validators.required]));
                            });
                            form_outras_definicoes.addControl(configuracao_plano.cod_configuracao_plano.toString(), form_outra_definicao);
                        }

                    });
                    this.form.addControl("diagnostico", form_diagnostico);
                    this.form.addControl("arquivo", form_arquivo);
                    if (this.possui_objetivos) {
                        this.form.addControl("objetivos", form_objetivos);
                    }
                    if (this.possui_metas) {
                        this.form.addControl("metas", form_metas);
                    }
                    if (this.possui_acoes_estrategicas) {
                        this.form.addControl("acoes_estrategicas", form_acoes_estrategicas);
                    }
                    if (this.possui_avaliacoes) {
                        this.form.addControl("avaliacoes", form_avaliacoes);
                    }
                    if (this.possui_outras_definicoes) {
                        this.form.addControl("outras_definicoes", form_outras_definicoes);
                    }
                }

                if(sgl_configuracao_grupo_plano == 'CHK' ){

                    this.carregarRevisaoMinuta(this.plano.cod_plano);
                }
                setTimeout(() => {
                    this.toggleDefinicoes(true);
                    this.form.valueChanges.subscribe(() => {
                        this.form_alterado = true;
                    });
                }, 1000);


            } else {
                this.router.navigateByUrl(this.url_redirect);
            }
            this.loadingService.hide();
            this.carregando = false;
        }, () => {
            this.loadingService.hide();
            this.carregando = false;
            this.router.navigateByUrl(this.url_redirect);
        });
    }

    initTinymce() {
        return TinymceService.getDefaultConfiguration();
    }

    finalizar(): void {
        this.save(true);
    }

    save(finalizar: boolean = false, automatico: boolean = false): void {

        this.form.markAsTouched();
        if (true) {
            let form: any = this.form.value;
            let textos_padroes: Array<string> = [];

            if (this.configuracoes_plano.length > 0) {

                this.configuracoes_plano.forEach((configuracao_plano: ConfiguracaoPlano) => {
                    if (configuracao_plano.txt_padrao) {
                        textos_padroes.push(configuracao_plano.txt_padrao);
                    }
                });
            }
            form.cod_plano = this.cod_plano;

            let objetivos_validados: boolean = false;
            let metas_validadas: boolean = false;
            let acoes_estrategicas_validadas: boolean = false;
            let avaliacoes_validadas: boolean = false;
            let outras_definicoes_validadas: boolean = false;
            let diagnosticos_validados: boolean = false;

            //Contadores
            let itens_nao_validados_apresentacao: number = 0;
            let itens_nao_validados_transporte: number = 0;
            let itens_nao_validados_circulacao: number = 0;
            let itens_nao_validados_infraestrutura: number = 0;
            let itens_nao_validados_acessibilidade: number = 0;
            let itens_nao_validados_integracao: number = 0;
            let itens_nao_validados_trasporte_carga: number = 0;
            let itens_nao_validados_polos: number = 0;
            let itens_nao_validados_estacionamento: number = 0;
            let itens_nao_validados_circulacao_restrita: number = 0;
            let itens_nao_validados_financiamento: number = 0;
            let itens_nao_validados_revisao: number = 0;



            let arrDiagnostico = [];
            let objDiagnostico = {};
            this.diagnosticoChecklist = [];

            if (form.diagnostico) {
                let texto_igual: boolean = false;
                for (var i in form.diagnostico) {
                    //form.diagnostico[i].desabilitar_definicoes = !form.diagnostico[i].desabilitar_definicoes;
                    if (textos_padroes.length > 0) {
                        textos_padroes.forEach((texto_padrao: string, j: number) => {
                            if (form.diagnostico[i].texto.trim() == texto_padrao.trim()) {
                                texto_igual = true;
                            }
                        });

                    }

                }
                diagnosticos_validados = !texto_igual;
            } else {
                diagnosticos_validados = true;
            }

            let arrObjetivo = [];
            if (form.objetivos) {
                if (this.possui_objetivos) {
                    for (var i in form.objetivos) {
                        for (var j in form.objetivos[i]) {
                            if (form.objetivos[i][j].objetivo) {
                                objetivos_validados = true;
                            }
                        }
                    }
                } else {
                    objetivos_validados = true;
                }
            } else {
                objetivos_validados = true;
                form.objetivos = [];
            }

            if (form.metas) {
                if (this.possui_metas) {
                    for (var i in form.metas) {
                        for (var j in form.metas[i]) {
                            if (form.metas[i][j].meta) {
                                metas_validadas = true;
                                console.log(form.metas);
                                form.metas[i][j].textos = isUndefined(this.meta_outros_textos[j]) ? [] : this.meta_outros_textos[j];
                            }else{
                            }
                        }
                    }
                } else {
                    metas_validadas = true;
                }
            } else {
                metas_validadas = true;
                form.metas = [];
            }
            if (form.acoes_estrategicas) {
                if (this.possui_acoes_estrategicas) {
                    for (var i in form.acoes_estrategicas) {
                        for (var j in form.acoes_estrategicas[i]) {
                            if (form.acoes_estrategicas[i][j].acao_estrategica) {
                                acoes_estrategicas_validadas = true;
                                form.acoes_estrategicas[i][j].textos = isUndefined(this.acao_estrategica_outros_textos[j]) ? [] : this.acao_estrategica_outros_textos[j];
                            }
                        }
                    }
                } else {
                    acoes_estrategicas_validadas = true;
                }
            } else {
                acoes_estrategicas_validadas = true;
                form.acoes_estrategicas = [];
            }
            if (form.avaliacoes) {
                if (this.possui_avaliacoes) {
                    for (var i in form.avaliacoes) {
                        for (var j in form.avaliacoes[i]) {
                            if (form.avaliacoes[i][j].avaliacao) {
                                avaliacoes_validadas = true;
                            }
                        }
                    }
                } else {
                    avaliacoes_validadas = true;
                }
            } else {
                avaliacoes_validadas = true;
                form.avaliacoes = [];
            }
            if (form.outras_definicoes) {
                if (this.possui_outras_definicoes) {
                    for (var i in form.outras_definicoes) {
                        for (var j in form.outras_definicoes[i]) {
                            if (form.outras_definicoes[i][j].outra_definicao) {
                                outras_definicoes_validadas = true;
                                form.outras_definicoes[i][j].textos = isUndefined(this.outra_definicao_outros_textos[j]) ? [] : this.outra_definicao_outros_textos[j];
                            }
                        }
                    }
                } else {
                    outras_definicoes_validadas = true;
                }
            } else {
                outras_definicoes_validadas = true;
                form.outras_definicoes = [];
            }

            //objetivos_validados && metas_validadas && acoes_estrategicas_validadas && avaliacoes_validadas && outras_definicoes_validadas && diagnosticos_validados
            if (true) {
                // alert (itens_nao_validados);
                this.loadingService.show();
                if (finalizar) {
                    form.sgl_situacao_plano = SituacaoPlano.FINALIZADO;
                }
                else if (form.sgl_situacao_plano == undefined) {
                    delete form.sgl_situacao_plano;
                }
                this.execucaoPlanoService.save(form, this.sgl_configuracao_grupo_plano).subscribe((data: any) => {

                    this.tabs.forEach((tab: any) => {
                        if (tab.sgl_configuracao_grupo_plano == this.sgl_configuracao_grupo_plano) {
                            tab.icon = true;
                        }
                    });

                    this.loadingService.hide();

                    if (finalizar) {
                        this.loadingService.show();
                        let plano_id: string = this.route.snapshot.params.plano;

                        this.acompanhamentoService.acompanhamento('finalizar', plano_id).subscribe((responseFinalizar: any) => {
                            if (responseFinalizar.responseCode == 500) {
                                this.loadingService.hide();
                                this.messageService.showError("Não foi possivel registrar a conclusão do acompanhamento");
                                this.messageService.showAlert("Não será feita uma tentativa de envio do link de avaliação !");
                            }

                            else if (responseFinalizar.responseCode == 200) {
                                this.acompanhamentoService.notificarGestor(plano_id).subscribe((responseNotificar) =>
                                    {
                                        this.loadingService.hide();
                                        this.messageService.showSuccess(responseNotificar.responseMessage);
                                        this.messageService.showSuccess(responseFinalizar.responseMessage.message);
                                    },
                                    (error) => {
                                        this.loadingService.hide();
                                        this.messageService.showError(error.responseMessage);
                                        this.messageService.showSuccess(responseFinalizar.responseMessage.message);
                                    }
                                );
                            }
                            this.router.navigateByUrl(this.url_redirect);
                        }, (error) => {
                            this.loadingService.hide();
                            this.messageService.showResponseError(error);
                        });

                    }
                    else {
                        if(!automatico){
                            this.messageService.showSuccess("Dados salvos com sucesso");
                        }
                    }
                    this.form_alterado = false;
                }, (error) => {
                    this.loadingService.hide();
                    this.messageService.showResponseError(error);
                });
            }
            else {
                if (!diagnosticos_validados) {
                    this.messageService.showError("Altere o texto que já vem por padrão");
                }
                if (!objetivos_validados) {
                    this.messageService.showError("Informe pelo menos um objetivo");
                }
                if (!metas_validadas) {
                    this.messageService.showError("Informe pelo menos uma meta");
                }
                if (!acoes_estrategicas_validadas) {
                    this.messageService.showError("Informe pelo menos uma ação estratégica");
                }
                if (!avaliacoes_validadas) {
                    this.messageService.showError("Informe pelo menos uma avaliação");
                }
                if (!outras_definicoes_validadas) {
                    this.messageService.showError("Informe pelo menos uma outra definição");
                }
            }
        }
        else {
            //this.messageService.showError("Informe todos os campos obrigatórios");
        }
    }

    changeTab(index: number): void {
        let sgl_configuracao_grupo_plano: string = null;
        let index_antigo: number = 0;
        this.tabs.forEach((tab: any, i: number) => {

            if (i == index) {
                sgl_configuracao_grupo_plano = tab.sgl_configuracao_grupo_plano;
            }
            if (tab.sgl_configuracao_grupo_plano == this.sgl_configuracao_grupo_plano) {
                index_antigo = i;
            }
        });
        if (index != index_antigo) {
            if (this.form_alterado) {
                let dialog: any = this.dialog.open(DialogConfirmarSairComponent, {width: '400px'});
                dialog.afterClosed().subscribe((result: any) => {
                    if (result.sair_sem_salvar) {
                        this.sgl_configuracao_grupo_plano = sgl_configuracao_grupo_plano;
                        this.carregarConfiguracaoGrupoPlano(sgl_configuracao_grupo_plano);
                    } else {
                        index = index_antigo;
                    }
                    this.tab_index = index;
                });
            } else {

                this.sgl_configuracao_grupo_plano = sgl_configuracao_grupo_plano;
                this.carregarConfiguracaoGrupoPlano(sgl_configuracao_grupo_plano);
                this.tab_index = index;
            }
        }
    }

    toggleDefinicoes(primeira_chamada: boolean = false): void {
        if (!primeira_chamada) {
            this.desabilitar_definicoes = !this.desabilitar_definicoes;
        }
        let buttons_adicionar: Array<Element> = Array.from(document.getElementsByClassName('buttons_adicionar'));
        let buttons_remover: Array<Element> = Array.from(document.getElementsByClassName('buttons_remover'));
        if (this.desabilitar_definicoes) {
            let checks_objetivos: Array<Element> = Array.from(document.getElementsByClassName('objetivos'));
            let checks_metas: Array<Element> = Array.from(document.getElementsByClassName('metas'));
            let checks_acoes_estrategicas: Array<Element> = Array.from(document.getElementsByClassName('acoes_estrategicas'));
            let checks_avaliacoes: Array<Element> = Array.from(document.getElementsByClassName('avaliacoes'));
            let checks_outras_definicoes: Array<Element> = Array.from(document.getElementsByClassName('outras_definicoes'));
            if (checks_objetivos.length > 0 && this.possui_objetivos) {
                checks_objetivos.forEach((element: Element) => {
                    let id_objetivo: Array<string> = element.id.split("_");
                    this.form.controls['objetivos'].get(id_objetivo[1]).get(id_objetivo[2]).patchValue({
                        objetivo: false,
                        texto: ""
                    });
                });
                this.form.controls["objetivos"].disable();
            }
            if (checks_metas.length > 0 && this.possui_metas) {
                checks_metas.forEach((element: Element) => {
                    let id_meta: Array<string> = element.id.split("_");
                    this.form.controls['metas'].get(id_meta[1]).get(id_meta[2]).patchValue({meta: false, texto: ""});
                });
                this.form.controls["metas"].disable();
            }
            if (checks_acoes_estrategicas.length > 0 && this.possui_acoes_estrategicas) {
                checks_acoes_estrategicas.forEach((element: Element) => {
                    let id_acao_estrategica: Array<string> = element.id.split("_");
                    this.form.controls['acoes_estrategicas'].get(id_acao_estrategica[2]).get(id_acao_estrategica[3]).patchValue({
                        acao_estrategica: false,
                        texto: ""
                    });
                });
                this.form.controls["acoes_estrategicas"].disable();
            }
            if (checks_avaliacoes.length > 0 && this.possui_avaliacoes) {
                checks_avaliacoes.forEach((element: Element) => {
                    let id_avaliacao: Array<string> = element.id.split("_");
                    this.form.controls['avaliacoes'].get(id_avaliacao[1]).get(id_avaliacao[2]).patchValue({
                        avaliacao: false,
                        texto: ""
                    });
                });
                this.form.controls["avaliacoes"].disable();
            }
            if (checks_outras_definicoes.length > 0 && this.possui_outras_definicoes) {
                checks_outras_definicoes.forEach((element: Element) => {
                    let outra_definicao: Array<string> = element.id.split("_");
                    this.form.controls['outras_definicoes'].get(outra_definicao[2]).get(outra_definicao[3]).patchValue({
                        outra_definicao: false,
                        texto: ""
                    });
                });
                this.form.controls["outras_definicoes"].disable();
            }
            if (buttons_adicionar && buttons_adicionar.length > 0) {
                buttons_adicionar.forEach((element: any) => {
                    element.disabled = true;
                });
            }
            if (buttons_remover && buttons_remover.length > 0) {
                buttons_remover.forEach((element: any) => {
                    element.disabled = true;
                });
            }
        } else {
            if (this.possui_objetivos) {
                this.form.controls["objetivos"].enable();
            }
            if (this.possui_metas) {
                this.form.controls["metas"].enable();
            }
            if (this.possui_acoes_estrategicas) {
                this.form.controls["acoes_estrategicas"].enable();
            }
            if (this.possui_avaliacoes) {
                this.form.controls["avaliacoes"].enable();
            }
            if (this.possui_outras_definicoes) {
                this.form.controls["outras_definicoes"].enable();
            }
            if (buttons_adicionar && buttons_adicionar.length > 0) {
                buttons_adicionar.forEach((element: any) => {
                    element.disabled = false;
                });
            }
            if (buttons_remover && buttons_remover.length > 0) {
                buttons_remover.forEach((element: any) => {
                    element.disabled = false;
                });
            }
        }
    }

    toggleCampoOutros(cod_configuracao_plano: number, codigo: number, checked: boolean, cadastrar_outros: boolean, item: string): void {
        if (cadastrar_outros) {

            this.disabled[item][cod_configuracao_plano][codigo] = checked;
            let itens: FormArray = this.form.get(item).get(cod_configuracao_plano.toString()).get(codigo.toString()).get('textos') as FormArray;
            if (itens && itens.controls.length > 0) {
                let buttons_adicionar: Array<Element> = Array.from(document.getElementsByClassName('buttons_adicionar_' + item));
                let buttons_remover: Array<Element> = Array.from(document.getElementsByClassName('buttons_remover_' + item));
                if (buttons_adicionar && buttons_adicionar.length > 0) {
                    buttons_adicionar.forEach((element: any) => {
                        element.disabled = !checked;
                    });
                }
                if (buttons_remover && buttons_remover.length > 0) {
                    buttons_remover.forEach((element: any) => {
                        element.disabled = !checked;
                    });
                }

                if (!checked) {
                    itens.controls.forEach((item: any, i: number) => {
                        item.get("codigo").setValue("");
                        item.get("descricao").setValue(" ");
                        if (i > 0) {
                            itens.removeAt(itens.length - 1);
                        }
                    });
                    if (item == "objetivos") {
                        this.objetivo_outros_textos[codigo].splice(0, this.objetivo_outros_textos[codigo].length);
                        this.objetivo_outros_textos[codigo].push({codigo: null, descricao: null});
                    } else if (item == "avaliacoes") {
                        this.avaliacao_outros_textos[codigo].splice(0, this.avaliacao_outros_textos[codigo].length);
                        this.avaliacao_outros_textos[codigo].push({codigo: null, descricao: null});
                    } else if (item == "outras_definicoes") {
                        this.outra_definicao_outros_textos[codigo].splice(0, this.outra_definicao_outros_textos[codigo].length);
                        this.outra_definicao_outros_textos[codigo].push({codigo: null, descricao: null});
                    }
                }
            }
        } else if (item == "metas" || item == "acoes_estrategicas") {
            let form_group: FormGroup = this.form.get(item).get(cod_configuracao_plano.toString()).get(codigo.toString()) as FormGroup;
            let form_control_check: FormControl;
            let itens: Array<any> = [];
            if (item == "metas") {
                form_control_check = form_group.get("meta") as FormControl;
            } else if (item == "acoes_estrategicas") {
                form_control_check = form_group.get("acao_estrategica") as FormControl;
            }
            if (form_control_check.value) {
                this.openDialogMetaAcaoEstrategica(cod_configuracao_plano, codigo, item, false);
            } else {
                if (item == "metas") {
                    form_group.patchValue({meta: true});
                } else if (item == "acoes_estrategicas") {
                    form_group.patchValue({acao_estrategica: true});
                }
                let dialog: any = this.dialog.open(DialogConfirmarExclusaoMetaAcaoEstrategicaComponent, {
                    width: '400px',
                    data: {
                        item: item
                    }
                });
                dialog.afterClosed().subscribe((result: any) => {
                    let pode_cancelar: boolean = result.pode_cancelar;
                    if (pode_cancelar) {
                        if (item == "metas" && !isUndefined(this.meta_outros_textos[codigo]) && this.meta_outros_textos[codigo].length > 0) {
                            this.meta_outros_textos[codigo] = [];
                        } else if (item == "acoes_estrategicas" && !isUndefined(this.acao_estrategica_outros_textos[codigo]) && this.acao_estrategica_outros_textos[codigo].length > 0) {
                            this.acao_estrategica_outros_textos[codigo] = [];
                        }
                        if (item == "metas") {

                            form_group.patchValue({meta: false});
                        } else if (item == "acoes_estrategicas") {
                            form_group.patchValue({acao_estrategica: false});
                        }
                    }
                });
            }
        }
    }

    addCampoOutros(cod_configuracao_plano: number, codigo: number, item: string): void {
        let check_name: string = "";
        if (item == 'objetivos') {
            check_name = "objetivo";
        } else if (item == "avaliacoes") {
            check_name = "avaliacao";
        } else if (item == "outras_definicoes") {
            check_name = "outra_definicao";
        }
        let itens: FormArray = this.form.get(item).get(cod_configuracao_plano.toString()).get(codigo.toString()).get('textos') as FormArray;
        let check: FormControl = this.form.get(item).get(cod_configuracao_plano.toString()).get(codigo.toString()).get(check_name) as FormControl;
        if (check.value) {
            itens.push(new FormGroup({codigo: new FormControl(), descricao: new FormControl()}));
            if (item == 'objetivos') {
                this.objetivo_outros_textos[codigo].push({codigo: null, descricao: null});
            } else if (item == "avaliacoes") {
                this.avaliacao_outros_textos[codigo].push({codigo: null, descricao: null});
            } else if (item == "outras_definicoes") {
                this.outra_definicao_outros_textos[codigo].push({codigo: null, descricao: null});
            }
        } else {
            this.messageService.showError("Para adicionar selecione o campo anterior");
        }
    }

    removeCampoOutros(cod_configuracao_plano: number, codigo: number, item: string): void {
        if (item == 'objetivos') {
            if (!isUndefined(this.objetivo_outros_textos[codigo]) && this.objetivo_outros_textos[codigo].length > 0) {
                this.objetivo_outros_textos[codigo].splice((this.objetivo_outros_textos[codigo].length - 1), 1);
            }
            console.log(this.objetivo_outros_textos[codigo]);
        } else if (item == 'avaliacoes') {
            if (!isUndefined(this.avaliacao_outros_textos[codigo]) && this.avaliacao_outros_textos[codigo].length > 0) {
                this.avaliacao_outros_textos[codigo].splice((this.avaliacao_outros_textos[codigo].length - 1), 1);
            }
        } else if (item == 'outras_definicoes') {
            if (!isUndefined(this.outra_definicao_outros_textos[codigo]) && this.outra_definicao_outros_textos[codigo].length > 0) {
                this.outra_definicao_outros_textos[codigo].splice((this.outra_definicao_outros_textos[codigo].length - 1), 1);
            }
        }
        let itens: FormArray = this.form.get(item).get(cod_configuracao_plano.toString()).get(codigo.toString()).get('textos') as FormArray;
        itens.removeAt(itens.length - 1);
    }

    openDialogMetaAcaoEstrategica(cod_configuracao_plano: number, codigo: number, item: string,
                                  mostrar_botao_voltar: boolean = true): boolean {
        let configuracao_plano: ConfiguracaoPlano;
        let titulo: string = "";
        let descricao: string = "";
        let nome_campo_check: string = "";
        let itens_outros: Array<any> = [];
        if (this.configuracoes_plano.length > 0) {
            this.configuracoes_plano.forEach((tmp_configuracao_plano: ConfiguracaoPlano) => {
                if (tmp_configuracao_plano.cod_configuracao_plano == cod_configuracao_plano) {
                    configuracao_plano = tmp_configuracao_plano;
                }
            });
        }
        if (item == 'metas') {
            titulo = "Meta";
            nome_campo_check = "meta";
            if (configuracao_plano && configuracao_plano.metas.length > 0) {
                configuracao_plano.metas.forEach((meta: Meta) => {
                    if (meta.cod_meta == codigo) {
                        descricao = meta.dsc_meta;
                    }
                });
            }
            itens_outros = isUndefined(this.meta_outros_textos[codigo]) ? [] : this.meta_outros_textos[codigo];

        } else if (item == 'acoes_estrategicas') {
            titulo = "Ação Estratégica";
            nome_campo_check = "acao_estrategica";
            if (configuracao_plano && configuracao_plano.acoes_estrategicas.length > 0) {
                configuracao_plano.acoes_estrategicas.forEach((acao_estrategica: AcaoEstrategica) => {
                    if (acao_estrategica.cod_acao_estrategica == codigo) {
                        descricao = acao_estrategica.dsc_acao_estrategica;
                    }
                });
            }
            itens_outros = isUndefined(this.acao_estrategica_outros_textos[codigo]) ? [] : Array.from(this.acao_estrategica_outros_textos[codigo]);
        }
        let form_group: FormGroup = this.form.get(item).get(cod_configuracao_plano.toString()).get(codigo.toString()) as FormGroup;

        if (form_group.get(nome_campo_check).value) {

            let dialog: any = this.dialog.open(DialogMetaAcaoEstrategicaComponent, {
                height: '600px',
                width: '600px',
                data: {
                    mostrar_botao_voltar: mostrar_botao_voltar,
                    codigo: codigo,
                    itens_outros: itens_outros,
                    item: item,
                    titulo: titulo,
                    descricao: descricao,
                }
            });
            dialog.afterClosed().subscribe((result: any) => {
                let pode_salvar: boolean = result.salvar;
                if (pode_salvar) {
                    if (item == 'metas') {
                        this.meta_outros_textos[codigo] = Array.from(result.itens_outros);
                    } else if (item == 'acoes_estrategicas') {
                        this.acao_estrategica_outros_textos[codigo] = Array.from(result.itens_outros);
                    }
                }
                if (!pode_salvar) {
                    if (result.itens_outros[0].descricao == null && item == "metas") {
                        form_group.patchValue({meta: false});
                    }
                    if (result.itens_outros[0].descricao == null && item == "acoes_estrategicas") {
                        form_group.patchValue({acao_estrategica: false});
                    }
                }
            });
        } else {
            this.messageService.showError("Para visualizar marque o campo ao lado");
        }
        return false;
    }

    openDialogTextoAuxiliar(texto: string): void {
        this.dialog.open(DialogTextoAuxiliarComponent, {
            height: '600px',
            width: '600px',
            data: {
                texto: texto,
            }
        });
    }

    openDialogEditarDesc(descricao: string, cod_arquivo: string): boolean {
        let dialog: any = this.dialog.open(DialogTextoAnexoComponent, {
            width: '600px',
            data: {
                texto: descricao,
                cod_arquivo: cod_arquivo
            }
        });
        dialog.afterClosed().subscribe((result: any) => {
            let codigo = this.cod_plano.toString();
            this.arquivoService.listAll(codigo).subscribe(data => {
                this.arquivos = data;
            })
        });
        return false;
    }

    upload(arquivo: HTMLInputElement, name: HTMLInputElement) {
        let codigo = this.cod_plano.toString();
        let file = arquivo.files[0];
        let descricao = name.value;

        var ext = file.name.substring(file.name.lastIndexOf('.') + 1);

        if (file.size > 20000000) {
            this.messageService.showError("Arquivo superior a 20MB");
            return false;
        }
        if (ext == 'bat' ||
            ext == 'exe' ||
            ext == 'com' ||
            ext == 'vbs' ||
            ext == 'msi' ||
            ext == 'scr'
        ) {
            this.messageService.showError("Extenção de arquivo não suportada");
            return false;
        }

        if (descricao == '') {
            this.messageService.showError("Informe uma descrição");
        }
        if (file == null) {
            this.messageService.showError("Informe um arquivo");

        }
        if (descricao !== '' && file !== null) {
            let formData = new FormData();
            formData.append('file', file, file.name);
            formData.append('cod_plano', codigo);
            formData.append('descricao', descricao);
            this.arquivoService.uploadFile(formData)
                .subscribe(data => {
                    name.value = '';
                    arquivo.value = null;
                    this.arquivos = data.files;
                    this.messageService.showSuccess("Anexo Salvo com sucesso");
                })
        }

    }

    removerArquivo(cod_arquivo): boolean {

        let dialog: any = this.dialog.open(DialogConfirmarExclusaoAnexoComponent, {
            width: '400px',
            data: {}
        });
        dialog.afterClosed().subscribe((result: any) => {
            let pode_cancelar: boolean = result.pode_cancelar;
            if (pode_cancelar) {
                let formData = new FormData();
                let codigo = this.cod_plano.toString();
                formData.append('cod_arquivo', cod_arquivo);
                formData.append('cod_plano', codigo);
                this.arquivoService.removeArquivo(formData).subscribe(data => {
                    this.arquivos = data.files;
                    this.messageService.showSuccess("Anexo removido com sucesso!")
                });
            }
        });
        return false;
    }

    download(cod_arquivo): void {
        this.arquivoService.downloadArquivo(cod_arquivo);
    }

    carregarRevisaoMinuta(cod_plano: number = null): void {
        this.showChecklist = false;
        this.execucaoPlanoService.revisarMinuta(cod_plano).subscribe(res => {
            this.conjuntoAbasCheklist = res;
            let contador = 0;
            this.conjuntoAbasCheklist.forEach(function(value) {
                if (value.numero_pendencias > 0) {
                    contador++;
                }
            });

            if (contador <= 0) {
                this.showBtnFinalizar = true;
            }
            //this.carregarConfiguracaoGrupoPlano('CHK', true);
        });
    }
}
